module.exports = __webpack_public_path__ + "img/rainbow.d7088d36.png";